import React, { useMemo, forwardRef } from 'react';
import PropTypes from 'prop-types';
import ButtonCore from '../Button/ButtonCore';
import Proportion from '../Proportion';
import { dataHooks } from './FillPreview.constants';
import { st, classes } from './FillPreview.st.css.js';
import { getBackgroundStyles } from './FillPreview.utils';
export const FillPreview = forwardRef(({ selected = false, className, aspectRatio, dataHook, disabled, fill, ...rest }, ref) => {
    const backgroundStyles = useMemo(() => {
        if (disabled || React.isValidElement(fill) || !fill) {
            return;
        }
        return getBackgroundStyles(fill);
    }, [fill, disabled]);
    return (React.createElement("div", { ref: ref, className: st(classes.root, className) },
        React.createElement(Proportion, { dataHook: dataHook, aspectRatio: aspectRatio },
            React.createElement(ButtonCore, { ...rest, "data-selected": selected, className: st(classes.button, {
                    selected,
                    empty: !fill && !disabled,
                }), "data-hook": dataHooks.button, style: backgroundStyles, disabled: disabled }, !backgroundStyles && React.isValidElement(fill) && fill))));
});
FillPreview.propTypes = {
    dataHook: PropTypes.any,
    className: PropTypes.any,
    as: PropTypes.any,
    fill: PropTypes.any,
    selected: PropTypes.any,
    disabled: PropTypes.any,
    aspectRatio: PropTypes.any,
};
export default FillPreview;
//# sourceMappingURL=FillPreview.js.map